import NhsPage from 'src/modules/nhs/nhsPage';
import WithErrorHandling from 'src/components/hoc/withErrorHandling';

import { fetchPopularNhsChoices } from 'src/api/nhs';
import { Community } from 'src/constants/types';


const Page = ({ communities }: { communities: Community[] }) => <NhsPage communities={communities} />;

Page.getInitialProps = async () => {
  const communities = await fetchPopularNhsChoices();

  return { communities };
};

export default WithErrorHandling(Page);
